export default {
  status: "Linehaul Status",
};
